/**
* DevExpress Dashboard (form-item-templates.js)
* Version:  24.1.7
* Build date: Oct 29, 2024
* Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
import dxButtonGroup from 'devextreme/ui/button_group';
import * as ko from 'knockout';
class FormItemTemplates {
}
FormItemTemplates.buttonGroup = (args) => {
    const div = document.createElement('div');
    if (!!args?.editorOptions?.items)
        args.editorOptions.items.forEach(x => x.hint = x.text);
    const options = {
        width: '100%',
        onSelectionChanged: e => args.component.updateData(args.dataField, e.component.option('selectedItemKeys')[0]),
        selectedItemKeys: [ko.unwrap(args.component.option('formData')[args.dataField])],
        ...args.editorOptions
    };
    new dxButtonGroup(div, options);
    return div;
};
export { FormItemTemplates };
